/** @jsxImportSource theme-ui */
import React, { useCallback } from 'react';
import { Box, Text, Spinner } from '@infotrack/zenith-ui';

import { useDashboardData } from './hooks/useDashboardData';
import { UserInfoSection } from './components/userInfoSection';
import { DashboardHeader } from './components/dashboardHeader';
import { dashboardPageStyles } from './dashboardPage.styles';

export const DashboardPage: React.FC = React.memo(function DashboardPage() {
  const { apiUser, displayName, isLoading, error } = useDashboardData();

  // Memoize callback functions to prevent unnecessary re-renders
  const handlePeriodChange = useCallback(() => {
    // TODO: Implement period change logic
  }, []);

  const handleFiltersChange = useCallback(() => {
    // TODO: Implement filters change logic
  }, []);

  if (isLoading) {
    return (
      <Box
        sx={dashboardPageStyles.loadingContainer}
        role="status"
        aria-live="polite"
      >
        <Spinner size="large" />
        <Text variant="medium">Loading dashboard...</Text>
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={dashboardPageStyles.errorContainer}
        role="alert"
        aria-live="assertive"
      >
        <Text variant="title" color="error">
          Unable to Load Dashboard
        </Text>
        <Box sx={{ mt: 2 }}>
          <Text variant="medium">{error}</Text>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={dashboardPageStyles.container}>
      {/* Dashboard Header */}
      <DashboardHeader
        resultCount={3}
        onPeriodChange={handlePeriodChange}
        onFiltersChange={handleFiltersChange}
      />

      {/* Main Content Area */}
      <Box sx={dashboardPageStyles.contentArea} role="main">
        <Box sx={dashboardPageStyles.contentBox}>
          <Box sx={dashboardPageStyles.heading}>
            <Text variant="hero">Dashboard</Text>
          </Box>
          <Box sx={dashboardPageStyles.welcomeText}>
            <Text variant="title">
              Welcome to the new iTopFive Dashboard
              {displayName ? `, ${displayName}` : ''}!
            </Text>
          </Box>
          <Box sx={dashboardPageStyles.subText}>
            <Text variant="medium">
              This is a placeholder implementation using Zenith UI components
            </Text>
          </Box>
        </Box>

        {/* API User Information */}
        {apiUser && <UserInfoSection apiUser={apiUser} />}
      </Box>
    </Box>
  );
});
